import Vue from "vue"
import ThemeConfigModal from './ThemeConfigModal.vue'

export default Vue.extend({
  components: {
    ThemeConfigModal
  },
  template: `
    <div style="display: flex">
      <vs-button
        v-if="$can('update', 'company')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-edit"
        @click="setEditCompany"
      ></vs-button>
      <vs-button
        v-if="$can('delete', 'company')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-trash-2"
        @click="setDeleteCompany"
      ></vs-button>
      <vs-button
        v-if="$can('update', 'company')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-settings"
        @click="openConfigModal"
      ></vs-button>
      <theme-config-modal ref="themeModal" @refreshTable="handleRefreshTable" />
    </div>
    `,
  data() {
    return {
      value: null
    }
  },
  methods: {
    setEditCompany () {
      if (this.params.data.id == null) {
        this.$vs.notify({
          text: this.$t("company.nonEditableCompany"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle"
        })
      } else this.$store.dispatch('company/set_company', this.params.data)
    },
    setDeleteCompany () {
      this.$store.dispatch('company/set_delete_company', this.params.data)
    },
    openConfigModal () {
      if (this.params.data.id == null) {
        this.$vs.notify({
          text: this.$t("company.nonEditableCompany"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle"
        })
      } else this.$refs.themeModal.open(this.params.data)
    },
    handleRefreshTable () {
      // Forward the refresh request to the AgGrid table component so the parent view can reload data
      if (this.params && this.params.context && this.params.context.componentParent) {
        this.params.context.componentParent.$emit('RefreshTableData')
      } else if (this.$root) {
        // Fallback event bus
        this.$root.$emit('RefreshTableData')
      }
    }
  }
})
